import { render, staticRenderFns } from "./ModelFilter.vue?vue&type=template&id=2ad84b20&"
import script from "./ModelFilter.vue?vue&type=script&lang=js&"
export * from "./ModelFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports